import api from '../../store/config/api';
import { USER as SCHEMA } from '../../schemas';

export const [
  AUTHENTICATION,
  AUTHENTICATION_REQUEST,
  AUTHENTICATION_SUCCESS,
  AUTHENTICATION_FAILURE
] = api.buildTypes('AUTHENTICATION');

export const [
  LOGOUT,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE
] = api.buildTypes('LOGOUT');

export const AUTHENTICATION_INVALIDATE = 'AUTHENTICATION_INVALIDATE';

export const authenticate = ({ teamName, username = '', password }) => {
  const { 'x-user-key': xUserKey, ...others } = api.defaults.headers;

  return {
    type: AUTHENTICATION,
    payload: {
      url: `/teams/${teamName}/auth`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        headers: { ...others },
        body: {
          username: username.toLowerCase(),
          password
        }
      }
    }
  };
};

export const authenticateSudoer = ({
  teamName,
  sudoeeUsername = '',
  sudoerUsername = '',
  sudoerPassword
}) => {
  const { 'x-user-key': xUserKey, ...others } = api.defaults.headers;

  return {
    type: AUTHENTICATION,
    payload: {
      url: `/teams/${teamName}/auth`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        headers: { ...others },
        body: {
          sudoeeUsername: sudoeeUsername.toLowerCase(),
          sudoerUsername: sudoerUsername.toLowerCase(),
          sudoerPassword
        }
      }
    }
  };
};

export const authenticateByToken = ({ teamName, username, token }) => ({
  type: AUTHENTICATION,
  payload: {
    url: `/teams/${teamName}/users/${username.toLowerCase()}/auth?token=${token}`,
    schema: SCHEMA
  }
});

export const invalidate = () => ({
  type: AUTHENTICATION_INVALIDATE
});

export const logout = ({ teamName, username }) => ({
  type: LOGOUT,
  payload: {
    url: `/teams/${teamName}/users/${username.toLowerCase()}/logout`,
    schema: {},
    options: {
      method: 'POST'
    }
  }
});

export const [
  GET_AUTHENTICATION_TOKEN,
  GET_AUTHENTICATION_TOKEN_REQUEST,
  GET_AUTHENTICATION_TOKEN_SUCCESS,
  GET_AUTHENTICATION_TOKEN_FAILURE
] = api.buildTypes('GET_AUTHENTICATION_TOKEN');

export const getAuthenticationToken = ({ teamName, username }) => ({
  type: GET_AUTHENTICATION_TOKEN,
  payload: {
    url: `/teams/${teamName}/users/${username.toLowerCase()}/auth`,
    schema: SCHEMA
  }
});

export const [
  GET_MAGIC_LINK,
  GET_MAGIC_LINK_REQUEST,
  GET_MAGIC_LINK_SUCCESS,
  GET_MAGIC_LINK_FAILURE
] = api.buildTypes('GET_MAGIC_LINK');

export const getMagicLink = ({ teamName, username }) => {
  const { 'x-user-key': xUserKey, ...others } = api.defaults.headers;
  return {
    type: GET_MAGIC_LINK,
    payload: {
      url: `/teams/${teamName}/users/${username.toLowerCase()}/auth`,
      schema: SCHEMA,
      options: {
        method: 'GET',
        headers: { ...others }
      }
    }
  };
};

export const [
  CHECK_AUTH_STATUS,
  CHECK_AUTH_STATUS_REQUEST,
  CHECK_AUTH_STATUS_SUCCESS,
  CHECK_AUTH_STATUS_FAILURE
] = api.buildTypes('CHECK_AUTH_STATUS');

export const checkAuthStatus = () => ({
  type: CHECK_AUTH_STATUS,
  payload: {
    url: `/auth/session/active`,
    schema: {}
  }
});



// WEBPACK FOOTER //
// ./js/actions/api/auth.js